/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Case_Type_Select_LabelInputs */

const en_automation_case_type_select_label = /** @type {(inputs: Automation_Case_Type_Select_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case type`)
};

const pt_br2_automation_case_type_select_label = /** @type {(inputs: Automation_Case_Type_Select_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de caso`)
};

/**
* | output |
* | --- |
* | "Case type" |
*
* @param {Automation_Case_Type_Select_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_case_type_select_label = /** @type {((inputs?: Automation_Case_Type_Select_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Case_Type_Select_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_case_type_select_label(inputs)
	return pt_br2_automation_case_type_select_label(inputs)
});